<template>
  <el-card
    class="tridlog-detail"
    shadow="never"
    :body-style="{ padding: '20px' }"
  >
    <div slot="header" class="clearfix">
      <span style="font-size: 16px">
        请求信息
        <el-button ref="copyBtn" type="text" size="mini">复制</el-button>
      </span>
    </div>

    <div ref="body" class="request-body">
      <div class="request-line" :class="{ 'is-empty': requestline === '' }">
        {{ requestline }}
      </div>
      <div
        v-for="(pair, index) in requestheanders"
        :key="'req:' + index"
        class="request-line"
      >
        <span style="font-weight: bold">{{ pair[0] }}:</span>
        {{ pair[1] }}
      </div>
      <div class="request-line" :class="{ 'is-empty': requestbody === '' }">
        {{ requestbody }}
      </div>
      <div class="request-line">
        =================== 响应内容 ===================
      </div>
      <div class="request-line" :class="{ 'is-empty': responseline === '' }">
        {{ responseline }}
      </div>
      <div
        v-for="(pair, index) in responseheaders"
        :key="'resp:' + index"
        class="request-line"
      >
        <span style="font-weight: bold">{{ pair[0] }}:</span>
        {{ pair[1] }}
      </div>
      <div class="request-line" :class="{ 'is-empty': responsebody === '' }">
        <highlight :value="responsebody" />
      </div>
    </div>
  </el-card>
</template>

<script>
import ClipboardJS from 'clipboard'
import highlight from '@/mixins/highlight.js'

export default {
  mixins: [highlight],
  props: {
    log: {
      type: Object,
      default: () => ({}),
    },
  },

  computed: {
    requestline() {
      const { method, url } = this.log || {}
      return `${method} ${url}`
    },

    requestheanders() {
      return this.handleHeaders((this.log || {}).requestHeaders)
    },

    requestbody() {
      const { requestBody } = this.log || {}

      return requestBody || ''
    },

    responseline() {
      const { status, reason } = this.log || {}

      return `${status} ${reason}`
    },

    responseheaders() {
      return this.handleHeaders((this.log || {}).responseHeaders)
    },

    responsebody() {
      const { responseBody } = this.log || {}
      return responseBody || ''
    },
  },

  mounted() {
    const btn = this.$refs.copyBtn

    if (btn) {
      console.log(btn.$el)
      const clipboard = new ClipboardJS(btn.$el, {
        target: () => this.$refs.body,
      })

      clipboard.on('success', e => {
        this.$message.success('复制成功')
        e.clearSelection()
      })

      clipboard.on('error', e => {
        this.$message.warning('请按 Ctrl+C 复制文字')
      })

      this.$on('destory', () => clipboard.destroy())
    }
  },

  beforeDestroy() {
    this.$emit('destory')
  },

  methods: {
    handleHeaders(body) {
      const headers = {}
      if (typeof body === 'string' && body.length) {
        let i = 0,
          j = body.length,
          k = [],
          l = []

        while (i < j) {
          const c = body.charAt(i++)

          if (c === ':') {
            k.push(i - 1)
          } else if (c === ';') {
            l.push(i - 1)
          }
        }
        l.push(j)

        i = 0

        for (let u = 0; u < k.length; u++) {
          for (let m = u + 1; m <= k.length; m++) {
            const index0 = k[u],
              index1 = k[m] || Infinity

            for (let t = l.length - 1; t >= 0; t--) {
              const lindex = l[t]

              if (lindex < index1 && lindex > index0) {
                const key = body.substring(i, index0).trim(),
                  value = body.substring(index0 + 1, lindex).trim()

                const items = headers[key] || (headers[key] = [])
                items.push(value)

                i = lindex + 1
                u = m
                break
              }
            }
          }
        }

        const keys = Object.keys(headers)
        keys.sort()
        const items = []
        keys.forEach(k => {
          headers[k].forEach(v => {
            items.push([k, v])
          })
        })
        return items
      }
      return []
    },
  },
}
</script>

<style lang="scss" scoped>
.tridlog-detail {
  .clearfix:before,
  .clearfix:after {
    display: table;
    content: '';
  }

  .clearfix:after {
    clear: both;
  }

  .setcolor {
    cursor: pointer;

    &:hover {
      color: #409eff;
    }
  }

  border: none;

  .request-body {
    padding: 5px;
    font-size: 13px;
    min-height: 300px;
    max-height: 550px;
    overflow-y: auto;
    border: 1px rgb(134, 132, 132) solid;
    border-radius: 2px;

    .request-line {
      line-height: 2;
      word-wrap: break-word;
      overflow: hidden;

      &.is-empty {
        width: 1px;
        height: 1em;
      }
    }
  }
}
</style>
